import { render } from "./Index.vue?vue&type=template&id=bb3fb65e"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=bb3fb65e&lang=scss"

import exportComponent from "G:\\司机仓库\\warehouseModule\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__